import { Component, Inject } from '@angular/core';
import {
    CookieService,
    IMenu,
    LocalStorageService,
    PERMISSOES_SERVICE_TOKEN,
    PermissoesService
} from '@sbt-suite/components';
import { environment } from 'src/environments/environment';
import { menuRoles } from './core/constants/roles';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    MODE = environment.MODE;
    URL_LOGIN = environment.URL_LOGIN;
    URL_LOGOUT = environment.URL_LOGOUT;

    menuItens: IMenu[] = [
        {
            label: '',
            roles: [],
            itens: [
                {
                    label: 'Home',
                    icone: 'home',
                    link: '/home',
                    roles: []
                }
            ]
        },
        {
            label: 'Solicitações',
            roles: menuRoles.itensMenu.solicitacoes.roles,
            itens: [
                {
                    label: 'Solicitações',
                    icone: 'attach_money',
                    link: '/solicitacoes',
                    roles: Object.values(menuRoles.itensMenu.solicitacoes.solicitacoes).flat()
                }
            ]
        },
        {
            label: 'Parametrizações',
            roles: menuRoles.itensMenu.parametrizacoes.roles,
            itens: [
                {
                    label: 'Área Executora',
                    icone: 'assignment',
                    link: '/areaexecutora',
                    roles: Object.values(menuRoles.itensMenu.parametrizacoes.areaExecutora).flat()
                },
                {
                    label: 'Categoria de Projeto',
                    icone: 'category',
                    link: '/categoriaprojeto',
                    roles: Object.values(
                        menuRoles.itensMenu.parametrizacoes.categoriaDeProjeto
                    ).flat()
                },
                {
                    label: 'Taxas Parametrizaveis',
                    icone: 'account_balance',
                    link: '/taxasparametrizaveis',
                    roles: Object.values(
                        menuRoles.itensMenu.parametrizacoes.taxasParametrizaveis
                    ).flat()
                }
            ]
        },
        {
            label: 'Questionario Qualitativo',
            roles: menuRoles.itensMenu.grupoQualitativo.roles,
            itens: [
                {
                    label: 'Grupos',
                    icone: 'group',
                    link: '/grupo-qualitativo',
                    roles: Object.values(menuRoles.itensMenu.grupoQualitativo.grupos).flat()
                },
                {
                    label: 'Critério',
                    icone: 'fact_check',
                    link: '/criterio',
                    roles: Object.values(menuRoles.itensMenu.grupoQualitativo.criterios).flat()
                },
                {
                    label: 'Questionário Qualitativo',
                    icone: 'view_list',
                    link: '/questionarioqualitativo',
                    roles: Object.values(
                        menuRoles.itensMenu.grupoQualitativo.questionarioQualitativo
                    ).flat()
                }
            ]
        },
        {
            label: 'Template',
            roles: menuRoles.itensMenu.template.roles,
            itens: [
                {
                    label: 'Upload de Arquivos',
                    icone: 'upload',
                    link: '/upload-arquivos',
                    roles: Object.values(menuRoles.itensMenu.template.uploadarquivos).flat()
                }
            ]
        }
    ];

    constructor(
        @Inject(PERMISSOES_SERVICE_TOKEN) private _permissoesService: PermissoesService,
        private _cookie: CookieService,
        private _localStorage: LocalStorageService
    ) {
        if (!environment.USE_BACKEND) {
            _localStorage.setItem('appToken', 'teste');
            _permissoesService.registrarPermissoes(['TESTE_VISUALIZAR']);
        }
        _permissoesService.initPermissoes();
    }

    async logout(event: boolean) {
        if (event) {
            try {
                this.clearCookie();
                this._localStorage.clear();
                window.open(this.URL_LOGOUT, '_self');
            } catch (error) {
                console.error(error);
            }
        }
    }

    private clearCookie() {
        let domain = '';
        if (this.MODE == 'dev' || this.MODE == 'prod') {
            domain = 'tvsbt.com.br';
        }
        this._cookie.delete(environment.ACCESS_TOKEN, '/', domain);
        this._cookie.delete(environment.REFRESH_TOKEN, '/', domain);
    }
}
